export enum Permissions {
  None = 'None',
  SupplierInvoiceManage = 'SupplierInvoicesManage', // no this permission from purchasing api yet.
  SupplierInvoiceView = 'SupplierInvoicesView',
  ProductCodeMapManage = 'ProductCodeMapManage',
  ProductCodeMapView = 'ProductCodeMapView',
}

export default Permissions;
